export default __webpack_public_path__ + "static/typography-image-x-674fa5b81a4136c6944d8ada16cb270a.png";